import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { slackLinkInfoQueryKey, type SlackLinkInfo } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface SlackLinkInfoResponse {
  success: boolean;
  slack_team_name: string | null;
  organization_id: number;
  is_member: boolean;
  already_linked: boolean;
}

export const useSlackLinkInfo = (token: string | null): UseQueryResult<SlackLinkInfo> => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: slackLinkInfoQueryKey(token ?? ""),
    enabled: !!token,
    retry: false,
    queryFn: async (): Promise<SlackLinkInfo> => {
      const res = await fetch(ENDPOINTS.slack.linkInfo(token ?? ""), {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      });
      const body: SlackLinkInfoResponse = await handleResponse(res);
      return {
        slackTeamName: body.slack_team_name,
        organizationId: body.organization_id,
        isMember: body.is_member,
        alreadyLinked: body.already_linked,
      };
    },
  });
};
